module.exports = __webpack_public_path__ + "img/bg-faqs.jpg";